import { Sports } from '@gin-betting/constants';

const getPromoTypeIdsBySport = (sportId?: string): number[] | null => {
    switch (sportId) {
        case Sports.ESPORTS_DOTA_2:
        case Sports.ESPORTS_LEAGUE_OF_LEGENDS:
        case Sports.ESPORTS_HEROES_OF_THE_STORM:
            return [50, 1, 20];

        case Sports.ESPORTS_COUNTER_STRIKE:
        case Sports.ESPORTS_RAINBOW_SIX:
            return [7, 1, 20];

        default:
            return null;
    }
};

export default getPromoTypeIdsBySport;
